import React from "react";
import { Assistant } from "./assistants";


type Props = {
    assistant: Assistant;
}


export default function AssistantTab({ assistant }: Props) {
    return (
        <div className="assistant-tab-container">
            <img src={assistant.iconUrl} alt={`${assistant.label} logo`} />
            {assistant.label}
        </div>
    );
}
